import React from 'react'
import { NavLink, generatePath } from 'react-router-dom'
import { routersPath } from '../../../router/routes-path'
import { 
  IconInfo, 
  IconChat, 
  IconCards,
  IconAccounts,
  IconCredits,
  IconInvestments,
  IconDocuments
} from '../../../utils/icons'

export const cabinetsTabs = (cabinetId: string) => [
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_INFO, { cabinetId })}>
        <IconInfo width='22' height='22' fill='var(--color-main)' />
        Информация
      </NavLink>
    ),
    pages: [routersPath.CABINET_INFO],
    fullPath: generatePath(routersPath.CABINET_INFO, { cabinetId })
  },
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_CHATS, { cabinetId })}>
        <IconChat width='22' height='22' fill='var(--color-main)' />
        Чат
      </NavLink>
    ),
    pages: [routersPath.CABINET_CHATS],
    fullPath: generatePath(routersPath.CABINET_CHATS, { cabinetId })
  },
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_CARDS, { cabinetId })}>
        <IconCards width='22' height='22' fill='var(--color-main)' />
        Карты
      </NavLink>
    ),
    pages: [routersPath.CABINET_CARDS],
    fullPath: generatePath(routersPath.CABINET_CARDS, { cabinetId })
  },
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_ACCOUNTS, { cabinetId })}>
        <IconAccounts width='22' height='22' fill='var(--color-main)' />
        Счета
      </NavLink>
    ),
    pages: [routersPath.CABINET_ACCOUNTS],
    fullPath: generatePath(routersPath.CABINET_ACCOUNTS, { cabinetId })
  },
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_CREDITS, { cabinetId })}>
        <IconCredits width='22' height='22' fill='var(--color-main)' />
        Кредиты
      </NavLink>
    ),
    pages: [routersPath.CABINET_CREDITS],
    fullPath: generatePath(routersPath.CABINET_CREDITS, { cabinetId })
  },
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_INVESTMENTS, { cabinetId })}>
        <IconInvestments width='22' height='22' fill='var(--color-main)' />
        Инвестиции
      </NavLink>
    ),
    pages: [routersPath.CABINET_INVESTMENTS],
    fullPath: generatePath(routersPath.CABINET_INVESTMENTS, { cabinetId })
  },
  {
    show: true,
    title: (
      <NavLink to={generatePath(routersPath.CABINET_DOCS, { cabinetId })}>
        <IconDocuments width='22' height='22' fill='var(--color-main)' />
        Документы
      </NavLink>
    ),
    pages: [routersPath.CABINET_DOCS],
    fullPath: generatePath(routersPath.CABINET_DOCS, { cabinetId })
  },
]

export const cabinetsTabsTitle = [
  {
    key: 0,
    title: 'Информация о клиенте',
  },
   {
    key: 1,
    title: 'Чаты клиента',
  },
   {
    key: 2,
    title: 'Карты клиента',
  },
   {
    key: 3,
    title: 'Счета клиента',
  },
  {
    key: 4,
    title: 'Кредиты клиента',
  },
  {
    key: 5,
    title: 'Инвестиции клиента',
  },
  {
    key: 6,
    title: 'Документы клиента',
  },
]
